import React from 'react'
import { DefaultLayout } from '../../layouts'
import { Container, Breadcrumb, SimplePageHeader } from '../../components'
import { RelatedResources } from '../resource-detail/components/related-resources'
import {
  Sidebar,
  BlogContent as Content,
  TestimoniSection,
  // StorySection,
  GallerySection,
  // JourneySection,
  BeneficiariesSection,
  // ImpactSection,
  RelatedPrograms,
  RelatedPosts,
  CommentSection,
  ActionButtons,
} from './components'
import auth from '../../utils/auth'
// import { RelatedPosts } from '../blog-detail/components/related-posts'
import rawData from '../../database/initiatives.json'
import { normalizer } from '../../utils'

const normalized = normalizer(rawData)

const routes = [
  {
    name: 'Home',
    route: '/'
  },
  {
    name: 'Initiative',
    route: '/program'
  },
]

const galleryImages = [
  '/images/inisiatif/Inisiatif-1.jpg',
  '/images/inisiatif/Inisiatif-2.jpg',
  '/images/inisiatif/Inisiatif-3.jpg',
  '/images/inisiatif/Inisiatif-4.jpg',
  '/images/inisiatif/Inisiatif-5.jpg',
  '/images/inisiatif/Inisiatif-6.jpg',
  '/images/inisiatif/Inisiatif-7.jpg',
  '/images/inisiatif/Inisiatif-8.jpg',
  // '/images/inisiatif/Inisiatif-9.jpg',
  // '/images/inisiatif/Inisiatif-10.jpg',
]

const ProgramDetail = ({ match }) => {
  const { isOfficial, isVerified, isUser } = auth()
  const bookmarkable = isOfficial || isVerified || isUser
  const data = normalized[match.params.id]

  const {
    title,
    content,
  } = data

  return (
    <DefaultLayout>
      <SimplePageHeader noPadding/>

      <Container className="pt-5 pb-10 lg:pt-20 lg:pb-20" color="#f5f5f5">
        <Breadcrumb className="mb-2 lg:mb-5" routes={routes} />

        <h1 className="text-2xl lg:text-5xl font-bold leading-tight mb-5 lg:mb-10 font-primary">
          {title}
        </h1>

        <div className="lg:hidden mb-6">
          <ActionButtons bookmarkable={bookmarkable}/>
        </div>

        <div className="flex flex-wrap -mx-4 overflow-x-hidden">
          <div className="w-full lg:w-8/12 px-4">
            <Content data={content}/>
            <hr className="my-10 lg:my-16"/>

            <div className="lg:hidden">
              <Sidebar
                isOfficial={isOfficial}
                bookmarkable={bookmarkable}
                data={data}
              />
            </div>

            {/* {
              isOfficial &&
              <div>
                <JourneySection />
                <hr className="my-10 lg:my-16"/>
                <BeneficiariesSection />
                <hr className="my-10 lg:my-16"/>
                <ImpactSection />
              </div>
            } */}

            <div>
              <BeneficiariesSection />
              <hr className="my-10 lg:my-16"/>
            </div>

            {/* <StorySection />
            <hr className="my-10 lg:my-16"/> */}

            <GallerySection images={galleryImages} />
          </div>
          <div className="hidden lg:block lg:w-3/12 px-4 ml-auto">
            <Sidebar isOfficial={isOfficial} data={data}/>
          </div>
        </div>
      </Container>

      <Container className="pt-5 pb-10 lg:pt-20 lg:pb-20">
        <TestimoniSection />

        <hr className="my-10 lg:my-20" />

        <CommentSection title={title}/>
      </Container>

      <Container className="hidden lg:block">
        <hr/>
      </Container>

      <RelatedPosts />

      <RelatedResources />

      <Container className="hidden lg:block">
        <hr/>
      </Container>

      <RelatedPrograms />
    </DefaultLayout>
  )
}

export { ProgramDetail }
